import { useContext } from 'react';
import { Client } from '@outdoorly/chat-sdk';
import { RemarkContext } from '../context';
import { useSubscription } from '../utilities';

export const useClient = (): Client => {
  const { client, inProvider } = useContext(RemarkContext);
  if (!inProvider || !client) {
    throw new Error('Your hook is not in a RemarkProvider');
  }
  return client;
};

export type withInitialized<T> = { initialized: boolean } & T;
export const useIsInitialized = (): boolean => useSubscription(useClient().initialized, false);
